import React from "react";
import { CSVBoxButton } from "@csvbox/react";
import { toast } from "react-toastify";

const SupplierCsvBoxComponent = ({ selectedSupplierId, selectedSupplierName, confirmationEmailUrl, confirmationEmailS3Key, onImportComplete }) => {
    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id');
    
    return (
        <CSVBoxButton 
            className="btn btn-success btn-lg shadow-sm"
            style={{
                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 30px',
                fontSize: '16px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)',
                textTransform: 'none'
            }}
            licenseKey="nTFFJ5NbbB4qfprje50If22cxjh9OV" // Using the same license key as supplier portal
            lazy={true}
            user={{
                user_id: user_id,
                supplier_id: selectedSupplierId,
                supplier_name: selectedSupplierName,
                confirmation_email_url: confirmationEmailUrl,
                confirmation_email_s3_key: confirmationEmailS3Key
            }}
            onImport={(result, data) => {
                if (result) {
                    toast.success('Import Completed Successfully!');
                    if (onImportComplete) {
                        onImportComplete(result, data);
                    }
                    setTimeout(() => {
                        window.location.href = "/suppliers-data";
                    }, 2000);
                } else {
                    toast.error('There was an issue with your upload. Please check your file format and try again.');
                }
            }}
            loadStarted={() => {
                console.log("Supplier CSV import loadStarted");
            }}
            onReady={() => {
                console.log("Supplier CSV import onReady");
            }}
            onClose={() => {
                console.log("Supplier CSV import onClose");
            }}
            onSubmit={(data) => {
                console.log("Supplier CSV import onSubmit");
                console.log("Import ID:", data.import_id);
                console.log("Selected Supplier ID:", selectedSupplierId);
                console.log("Selected Supplier Name:", selectedSupplierName);
                console.log("Confirmation Email URL:", confirmationEmailUrl);
                console.log("Confirmation Email S3 Key:", confirmationEmailS3Key);
            }} 
            options={{
                request_headers: {
                    "Authorization": "Bearer " + token,
                    "X-Supplier-Id": selectedSupplierId,
                    "X-Supplier-Name": selectedSupplierName,
                    "X-Confirmation-Email-Url": confirmationEmailUrl || "",
                    "X-Confirmation-Email-S3Key": confirmationEmailS3Key || ""
                },
            }}
        >
            <i className="ti-import" style={{marginRight: '8px', fontSize: '18px'}}></i> 
            Import Data
        </CSVBoxButton>
    );
};

export default SupplierCsvBoxComponent;